"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [0, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_places_autocomplete_1 = require("react-places-autocomplete");

var util_1 = require("../util");

require("./form.less");

require("./address.less");

;

var Address = function (_super) {
  __extends(Address, _super);

  function Address(props) {
    var _this = _super.call(this, props) || this;

    var address = {};
    var value = props.value || {};
    ["address", "lat", "lng"].forEach(function (key) {
      switch (key) {
        case "address":
          address[key] = value[key] || "";
          break;

        case "lat":
          address[key] = value[key] || 51.5073509;
          break;

        case "lng":
          address[key] = value[key] || -0.12775829999998223;
          break;
      }
    });
    _this.state = {
      value: address,
      isValid: !!props.value,
      text: address.address
    };
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  Address.prototype.componentWillReceiveProps = function (nextProps) {
    var _this = this;

    if (!!nextProps.value && nextProps.value !== this.state.value) {
      var address_1 = {};
      var value_1 = nextProps.value || {};
      ["address", "lat", "lng"].forEach(function (key) {
        switch (key) {
          case "address":
          case "lat":
          case "lng":
            address_1[key] = _this.state.value[key] || value_1[key];
            break;
        }
      });
      this.setState({
        value: address_1,
        isValid: true,
        text: nextProps.value.address
      });
    }
  };

  Address.prototype.onChange = function (address) {
    return __awaiter(this, void 0, void 0, function () {
      var geocodes, _a, lat, lng, value, _b, context, field, isValid, fieldName;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4
            /*yield*/
            , react_places_autocomplete_1.geocodeByAddress(address)];

          case 1:
            geocodes = _c.sent();
            return [4
            /*yield*/
            , react_places_autocomplete_1.getLatLng(geocodes[0])];

          case 2:
            _a = _c.sent(), lat = _a.lat, lng = _a.lng;
            value = {
              address: address,
              lat: lat,
              lng: lng
            };
            return [4
            /*yield*/
            , this.setState({
              text: address,
              value: value,
              isValid: true
            })];

          case 3:
            _c.sent();

            _b = this.props, context = _b.context, field = _b.field;
            isValid = this.state.isValid;

            if (field instanceof Object) {
              Object.keys(this.props.field).forEach(function (key) {
                switch (key) {
                  case "address":
                  case "lat":
                  case "lng":
                    var fieldName = field[key];
                    var content = value[key];
                    context.onValue(fieldName, content, isValid);
                    break;

                  default:
                    break;
                }
              });
            } else {
              fieldName = field;
              context.onValue(fieldName, address, isValid);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Address.prototype.render = function () {
    var _this = this;

    var inputProps = {
      value: this.state.text,
      onChange: function onChange(text) {
        _this.setState({
          text: text
        });
      },
      placeholder: "Search for address"
    };
    var inputOptions = {
      componentRestrictions: {
        country: "uk"
      }
    };
    var label = "";

    if (this.props.label) {
      var className = this.props.required ? "required" : "";
      label = React.createElement("label", {
        className: className
      }, this.props.label);
    }

    var _a = this.state.value,
        lat = _a.lat,
        lng = _a.lng;
    var hideMap = this.props.hideMap;
    var cssClasses = {
      autocompleteContainer: 'map-autocomplete-container',
      autocompleteItem: 'map-autocomplate-item',
      autocompleteItemActive: 'map-autocomplate-item-active'
    };
    var zoom = this.state.value.address ? 15 : 6;
    var showMarker = this.state.value.address ? true : false;
    return React.createElement("div", {
      className: "input"
    }, label, React.createElement(react_places_autocomplete_1["default"], {
      inputProps: inputProps,
      classNames: cssClasses,
      onEnterKeyDown: this.onChange,
      onSelect: this.onChange,
      options: inputOptions
    }), !hideMap && React.createElement(util_1.Map, {
      zoom: zoom,
      showMarker: showMarker,
      center: {
        lat: lat,
        lng: lng
      }
    }));
  };

  return Address;
}(React.Component);

exports["default"] = Address;